<template>
  <div class="relative pb-4">
    <div class="flex items-start mb-2 -ml-1 space-x-2">
      <div
        v-if="type === 'toSign' || document.recipients.length > 1"
        class="flex flex-col mt-1 space-y-1 md:-ml-9"
      >
        <RecipientBadge
          v-if="type === 'toSign'"
          show-icon
          :is-pending="isRecipientPending"
          small
        />
        <AllRecipientsBadge
          v-if="document.recipients.length > 1"
          class="select-none"
          status="allRecipients"
          :document="document"
          :are-recipients-pending="areRecipientsPending"
          small
        />
      </div>

      <div>
        <div class="flex items-center mb-2 space-x-1">
          <BaseIcon
            class="-ml-1 md:w-10 md:h-10"
            size="30"
          >
            <PDFIcon />
          </BaseIcon>

          <span
            class="pr-8 pr-12 text-base leading-snug text-neutral-1 line-clamp-2 break-words font-medium"
          >
            {{ document.name }}
          </span>
        </div>

        <BaseButton
          v-if="isRecipientPending"
          :loading="loading"
          :disabled="loading || !previousSigningCompleted"
          :on-click="showDocument"
        >
          {{ t("document.signDocument") }}
        </BaseButton>

        <BaseButton
          v-else
          :loading="loading"
          :on-click="showDocument"
        >
          {{ t("document.showDocument") }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import {useStore} from "vuex";
import { useI18n } from "vue-i18n";
import useDocument from "../../composables/Document/useDocument";
import RecipientBadge from "./RecipientBadge";
import AllRecipientsBadge from "./AllRecipientsBadge";
import PDFIcon from "../icons/IconPDF";

export default {
  components: {
    PDFIcon,
    AllRecipientsBadge,
    RecipientBadge,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    recipient: {
      type: Object,
      required: true,
    },
    requestId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    isRecipientPending: {
      type: Boolean,
      required: true,
      default: false,
    },
    areRecipientsPending: {
      type: Boolean,
      required: false,
      default: false,
    },
    previousSigningCompleted: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  setup(props) {
    const store = useStore();
    const { t } = useI18n();
    const { loading, showDocument } = useDocument(
      props.requestId,
      props.document.id,
      store
    );

    return {
      t,
      loading,
      showDocument,
    };
  },
};
</script>
